var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.elClass},[_c('button',{staticClass:"btn btn-info btn-sm",class:{disabled: !_vm.sendable},attrs:{"type":"button","disabled":!_vm.sendable},on:{"click":_vm.sendGdPin}},[_vm._v(_vm._s(_vm.buttonText))])])}
var staticRenderFns = []

export { render, staticRenderFns }